// extracted by mini-css-extract-plugin
export var label = "industrial-design-module--label--3NNRM";
export var fadein = "industrial-design-module--fadein--93hhB";
export var hide = "industrial-design-module--hide--1HBi4";
export var fadeout = "industrial-design-module--fadeout--2_er3";
export var absoluteClickableContainer = "industrial-design-module--absoluteClickableContainer--1f6aF";
export var leftClickableContainer = "industrial-design-module--leftClickableContainer--YTtzP";
export var rightClickableContainer = "industrial-design-module--rightClickableContainer--1uPuL";